import { LoadingButton } from '@mui/lab';
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { DEFAULT_ERROR_MESSAGE } from '@/constants/app/config';
import { useGetMachineQuery } from '@/store/api/services/machines/machine';
import { usePatchNoteDispenserMutation } from '@/store/api/services/restocking/restocking';

import type { ModalChildrenProps } from '@bitstopco/bitstop-theme';

const EditInventoryThreshold = ({ props, hide }: ModalChildrenProps) => {
  const index = props?.index;
  const id = props?.atmId;
  const [count, setCount] = useState(0);
  const [updateDispenser, { isLoading }] = usePatchNoteDispenserMutation();
  const {
    data: { data: machine = null } = {},
  } = useGetMachineQuery(id ?? skipToken);

  const handleUpdate = async () => {
    try {
      await updateDispenser({
        atm: id,
        request: {
          cassetes: [{ hardware_cassette_slot: index, low_quantity_threshold: count }],
        },
      }).unwrap();
      toast.success('Threshold updated successfully');
      hide();
    } catch (error) {
      toast.error((error as any).message ?? DEFAULT_ERROR_MESSAGE);
    }
  };

  useEffect(() => {
    if (!machine || !id || !index) return;
    const cassetteCount =
      machine.note_dispenser_cassettes?.find(({ cassette_index }) => cassette_index === index)
        ?.low_quantity_threshold ?? 0;
    setCount(cassetteCount);
  }, [machine, id, index]);

  return (
    <>
      <DialogContent>
        <Stack gap={1} py={3}>
          <TextField
            value={count}
            type="number"
            label="Threshold"
            placeholder="Threshold"
            onChange={({ target }) => setCount(+target.value)}
          />
          <Typography>
            Displays the minimum note level set for this cassette. When the note count goes below
            this value, it will be indicated in the system.
          </Typography>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={hide}>Close</Button>
        <LoadingButton onClick={handleUpdate} loading={isLoading} variant="contained">
          Update
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default EditInventoryThreshold;
